import React from "react";

export default function EmptyState({ msg = "No hay datos" }) {
  return <div className="text-center p-3">{msg}</div>;
}
